import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';

export default (element) => {
  // Function to initialize Swiper
  const initializeSwiper = (container, options) => {
    if (!container) {
      return;
    }

    // eslint-disable-next-line no-new
    new Swiper(container, options);
  };

  // Swiper container
  const swiperContainer = element.querySelector('.swiper');
  const dataOnlyImages = element.querySelector('[data-only-images]');
  const numberOfSlides = dataOnlyImages ? 4.1 : 2.3;
  // Swiper configuration
  const swiperOptions = {
    slidesPerView: 2.2,
    spaceBetween: 10,
    slidesOffsetAfter: 20,
    navigation: {
      prevEl: element.querySelector('[data-icon-left]'),
      nextEl: element.querySelector('[data-icon-right]'),
    },
    breakpoints: {
      1024: {
        slidesOffsetAfter: 0,
        slidesOffsetBefore: 0,
        slidesPerView: numberOfSlides,
        spaceBetween: 20,
      },
    },
  };

  // Initialize Swiper using the helper function
  initializeSwiper(swiperContainer, swiperOptions);
};
